import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { colors } from '../constants/colors';
import Button from './Button';
import {commonStrings} from '../components/StringBundle';

const useStyles = makeStyles((theme) => ({
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    boxShadow: theme.shadows[5],
    outline: 'none',
    maxHeight: '93vh',
    overflowY: 'hidden',  
    width: '90%', // fallback width for very small screens
    maxWidth: '100%',
  },
  scrollableBodymodalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    boxShadow: theme.shadows[5],
    outline: "none",
    maxHeight: "90vh",
    width: "90%",
    maxWidth: "100%",
    display: "flex",
    flexDirection: "column",
  },
  customSize: {
    width: 400
  },
  sm: {
    maxWidth: 600,
  },
  md: {
    maxWidth: 900,
  },
  lg: {
    maxWidth: 900,
  },
  xl: {
    maxWidth: 1536,
  },
  scrollableBodyHeader: {
    flexShrink: 0, 
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#feecda",
    padding: theme.spacing(2),
    borderBottom: `1px solid ${colors.orange}`,
    marginBottom: '5px'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid ${colors.grayLight}`,
    backgroundColor: '#feecda',
    padding: theme.spacing(2),
    borderBottom: `1px solid ${colors.orange}`,
    marginBottom: '5px'
  },
  body: {
    padding: theme.spacing(2),
    maxHeight: "70vh",
    overflow: "auto",
  [theme.breakpoints.down('sm')]: {
    paddingRight: theme.spacing(2),
  },
  },
  scrollableBodyClass: {
    flex: 1, 
    padding: theme.spacing(2),
    overflowY: "auto",
  },
  scrollableBodyClass: {
    flex: 1, 
    padding: theme.spacing(2),
    overflowY: "auto",
  },
  footer: {
    borderTop: `1px solid ${colors.grayLight}`,
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(1),
    borderTop: `1px solid ${colors.orange}`,
  },
  scrollableBodyfooter: {
    flexShrink: 0, 
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(1),
    borderTop: `1px solid ${colors.orange}`,
  },
  title: {
    fontSize: '1.375rem',
    fontWeight: 600,
    color: colors.black,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.125rem',
    },

    [theme.breakpoints.down('xs')]: {
      fontSize: '1rem',
    },
  },
  paper: {
    '& #simple-modal-title': {
      color: colors.orange
    }
  },
  modal_overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
    pointerEvents: 'all',
    '& p': {
      fontSize: '24px',
      color: '#fff',
      textAlign: 'center',
    }
  },
  modalContainerRelative: {
    position: 'relative',
  }
}));


export default function SimpleModal(props) {
  const classes = useStyles();
  const {
    open,
    handleClose,
    header,
    body,
    footer,
    size = 'md',
    isNew = false,
    isFooter = false,
    hasCloseIcon = true,
    hasCancel = true,
    isDisabled = false,
    scrollableBody = false,
    isLoading = false,
    cancelButtonName = commonStrings.cancel
  } = props;

  const onClose = (event, reason) => {
    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
      handleClose();
    }
  };


  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      className={classes.paper}
    >
      <div
         className={
          `${scrollableBody 
              ? classes.scrollableBodymodalContainer 
              : isNew 
                ? `${classes.modalContainer} ${size === 'custom' ? classes.customSize : classes[size]}` 
                : ""} 
          ${isLoading ? classes.modalContainerRelative : ""}`
        }
      >
        {isLoading && (
          <div className={classes.modal_overlay}>
            <p>{commonStrings.dataSaving}</p>
          </div>
        )}
        {header && (
          <div
            className={
              scrollableBody ? classes.scrollableBodyHeader : classes.header
            }
          >
            <div className={classes.title}>{header}</div>
            {hasCloseIcon && (
              <IconButton size="small" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            )}
          </div>
        )}

        <div
          id="simple-modal-description"
          className={
            scrollableBody ? classes.scrollableBodyClass : classes.body
          }
        >
          {body()}
        </div>

        {isFooter && (
          <div
            className={
              scrollableBody ? classes.scrollableBodyfooter : classes.footer
            }
          >
            {footer}
            {hasCancel && (
              <Button
                onClick={handleClose}
                disabled={isDisabled || false}
                label={cancelButtonName}
              />
            )}
          </div>
        )}
      </div>
    </Modal>
  );
}